var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCareersBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 582,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1179.77,
    y: 60,
    width: 6.452,
    height: 40,
    rx: 3.226,
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1203,
    y: 75.484,
    width: 6.452,
    height: 40,
    rx: 3.226,
    transform: "rotate(90 1203 75.484)",
    fill: "#F9DB6D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1ODIiIHZpZXdCb3g9IjAgMCAxNDQwIDU4MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTE3OS43NyIgeT0iNjAiIHdpZHRoPSI2LjQ1MTYxIiBoZWlnaHQ9IjQwIiByeD0iMy4yMjU4MSIgZmlsbD0iI0Y5REI2RCIvPgo8cmVjdCB4PSIxMjAzIiB5PSI3NS40ODM5IiB3aWR0aD0iNi40NTE2MSIgaGVpZ2h0PSI0MCIgcng9IjMuMjI1ODEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDEyMDMgNzUuNDgzOSkiIGZpbGw9IiNGOURCNkQiLz4KPC9zdmc+Cg==";
export { SvgCareersBg as ReactComponent };